import React from 'react';
import { Card } from 'V2/Shared/Card';
import colorLogo from 'V2/Shared/Assets/logo-color.svg';
import styles from '../styles.module.css';

export const CheckoutLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className={styles.root}>
    <div className={styles.logoWrapper}>
      <img src={colorLogo} alt="Clearcover" className={styles.logo} />
    </div>
    <Card className={styles.card}>{children}</Card>
  </div>
);
